import { render, staticRenderFns } from "./RiderDetail.vue?vue&type=template&id=032605c6&scoped=true&"
import script from "./RiderDetail.vue?vue&type=script&lang=js&"
export * from "./RiderDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiderDetail.vue?vue&type=style&index=0&id=032605c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032605c6",
  null
  
)

export default component.exports